import Service from "../models/domain/Service";
import { ServiceResponse } from "../models/serviceApi/ServiceResponse";

export default class ServiceMapper {
  static map(response: ServiceResponse): Service {
    return {
      id: response.id,
      name: response.name,
      serviceType: response.serviceType,
      serviceTypeLabel: response.serviceTypeLabel,
      defaultPrice: response.defaultPrice,
      referenceType: response.referenceType,
      referenceName: response.referenceName,
      isGlobal: response.isGlobal,
    };
  }

  static mapList(response: ServiceResponse[]): Service[] {
    return response.map(ServiceMapper.map);
  }
}
